import axios from 'axios';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { QrReader } from 'react-qr-reader';
import CONFIG from '../constanta/config';
import Cookies from 'js-cookie';

const PopupAddUser = (props) => {
  const [msgerror, setMsgerror] = useState('');
  const [msgsuskes, setMsgsukses] = useState('');
  const [msgName, setMsgName] = useState('');
  const [loading, setLoading] = useState(false);
  const [sukses, setSukses] = useState(false);

  const handleSubmit = () => {
    setMsgName('');

    let name = getValue();
    if (name === '') {
      setMsgName('Please type your name');
      return;
    }

    let dob = getValueDOB();
    if (dob === '') {
      setMsgName('Please type your date of birth');
      return;
    }


    let location = getValueLocation();
    if (location === '') {
      setMsgName('Please choose your location');
      return;
    }

    setLoading(true);
    setSukses(false);

    const payload = {
      firstname: name,
      lastname: '',
      dob: dob,
      attendance: location
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    console.log(Cookies.get('token'));

    axios
      .post(CONFIG.URL + '/user/addevent', form_data, {
        headers: {
          token: Cookies.get('token')
        }
      })
      .then(function (response) {
        if (response?.data.status === 'SUCCESS') {
          setSukses(true);
          setMsgsukses('Success add user');


          setTimeout(() => {
            props.onSuccess();
          }, 1500);

          openInNewWindow(
            `/printcode?name=${response?.data?.firstname}&code=${response?.data?.qr_code}`
          );
        } else {
          setMsgerror('Error add user please try again.');
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const getValue = () => {
    let name = window.document.getElementById('input_name').value;
    return name;
  };

  const getValueDOB = () => {
    let dob = window.document.getElementById('input_dob').value;
    return dob;
  };

  const getValueLocation = () => {
    let location = document.getElementById('attendance').value;
    return location;
  };

  const openInNewWindow = (url) => {
    const windowFeatures =
      'menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes,width=800,height=600';
    const newWindow = window.open(url, '_blank', windowFeatures);

    if (newWindow) {
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
          newWindow.onafterprint = () => {
            newWindow.close();
          };
        }, 1000);
      };
    }
  };

  return (
    <>
      <form className="w-full">
        <div className="absolute z-20 top-0 left-0 w-screen h-screen bg-[#000000b3]"></div>
        <div className="absolute py-20 z-50  top-0 left-0 w-screen h-screen flex flex-col justify-center items-center">
          <div className="p-4 bg-white rounded-lg w-full max-w-lg">
            <div className="flex flex-col space-y-2 mb-10">
              <div className=" text-black text-center font-bold text-2xl uppercase">
                ADD USER
              </div>
            </div>
            <div className=" flex flex-col w-full max-w-lg">
              {!sukses && (
                <>
                  <div className="text-black mb-1">Name:</div>
                  <input
                    autoFocus
                    id="input_name"
                    placeholder="Type your name"
                    autocomplete="off"
                    className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                  />

                  <div className="text-black mb-1 mt-4">Date of Birth:</div>
                  <input
                    type="date"
                    id="input_dob"
                    placeholder="Type your birth"
                    autocomplete="off"
                    className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                  />

                  <div className="text-black mb-1 mt-4">Location:</div>
                  <select
                    id="attendance"
                    className="w-full min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black">
                    <option value="" disabled selected>
                      Choose location
                    </option>
                    <option value="Trinidad">Trinidad</option>
                    <option value="Tobago">Tobago</option>
                  </select>
                </>
              )}
              {msgName !== '' && (
                <div className="w-full mt-2 max-w-lg text-left px-2 rounded-md bg-white text-red-500">
                  {msgName}
                </div>
              )}

              {msgerror !== '' && !sukses && (
                <div className="mt-10 w-full max-w-lg text-center py-2 px-2 rounded-md my-2 bg-red-500 text-white font-bold">
                  {msgerror}
                </div>
              )}

              {msgsuskes !== '' && (
                <div className="uppercase w-full max-w-lg text-center py-2 px-2 rounded-md my-2  text-green-500 font-bold">
                  {msgsuskes}
                </div>
              )}
            </div>

            {!loading ? (
              <>
                {sukses ? (
                  <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                    {/* <button
                      type="button"
                      onClick={() => props.onSuccess()}
                      className="min-w-[160px] px-10 py-2 bg-green-500 rounded-lg text-white font-bold">
                      OK
                    </button> */}
                  </div>
                ) : (
                  <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                    <button
                      type="button"
                      onClick={() => props.onClose()}
                      className="min-w-[160px] px-10 py-2 bg-red-500 rounded-lg text-white font-bold">
                      CANCEL
                    </button>

                    <button
                      type="button"
                      onClick={() => handleSubmit()}
                      className="min-w-[160px] px-10 py-2 bg-blue-500 rounded-lg text-white font-bold">
                      SUBMIT
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                <button
                  type="button"
                  onClick={() => props.onSuccess()}
                  className="min-w-[160px] px-10 py-2 bg-transparent rounded-lg text-black font-bold">
                  Loading, please wait...
                </button>
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default PopupAddUser;
